/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2026-02-27 19:37:07
 * @LastEditors: 倪国晓
 * @LastEditTime: 2026-02-27 19:56:22
 */
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  render: (h) => h(App),
}).$mount('#app')
